import React from 'react';
import {Avatar, Card, CardContent, CardHeader, List, ListItem, ListItemText} from "@material-ui/core";
import ContactPhoneIcon from "@material-ui/icons/ContactPhone";

const ContactCard = ({contactData, title, cardClasses}) => (
    <Card component={Card} className={cardClasses.card}>
        <div>
            <CardHeader
                avatar={
                    <Avatar aria-label="type" className={cardClasses.contact}>
                        <ContactPhoneIcon/>
                    </Avatar>
                }
                title={title}
                subheader={'Contact Info'}
            />
            <CardContent>
                <List>
                    <ListItem>
                        <ListItemText>
                            <strong>Name:</strong> {contactData.name || 'N/A'}
                        </ListItemText>
                    </ListItem>
                    <ListItem>
                        <ListItemText>
                            <strong>Email:</strong> {contactData.email || 'N/A'}
                        </ListItemText>
                    </ListItem>
                    <ListItem>
                        <ListItemText>
                            <strong>Phone:</strong> {contactData.phone || 'N/A'}
                        </ListItemText>
                    </ListItem>
                    <ListItem>
                        <ListItemText>
                            <strong>Website:</strong> {contactData.website || 'N/A'}
                        </ListItemText>
                    </ListItem>
                </List>
            </CardContent>
        </div>
    </Card>
);

export default ContactCard;
